import { render, staticRenderFns } from "./LinkedProductsEndPage.vue?vue&type=template&id=dbcac4a4&scoped=true&"
import script from "./LinkedProductsEndPage.vue?vue&type=script&lang=js&"
export * from "./LinkedProductsEndPage.vue?vue&type=script&lang=js&"
import style0 from "./LinkedProductsEndPage.vue?vue&type=style&index=0&id=dbcac4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcac4a4",
  null
  
)

export default component.exports